import { multipropriedadeConfig as config } from "../../config/niches/multipropriedade";
import { usePageMeta } from "../../hooks/usePageMeta";
import { NicheTopBar } from "../../components/niche/NicheTopBar";
import { NicheHero } from "../../components/niche/NicheHero";
import { MultipropriedadeFlow } from "../../components/niche/MultipropriedadeFlow";
import { LegalInfo } from "../../components/niche/LegalInfo";
import { Footer } from "../../components/shared/Footer";
import { NicheGuides } from "../../components/niche/NicheGuides";
import { IndependenceBanner } from "../../components/shared/IndependenceBanner";

export default function MultipropriedadePage() {
  usePageMeta(config.metaTitle, config.metaDescription);
  return (
    <div className="flex min-h-screen flex-col">
      <IndependenceBanner />
      <NicheTopBar badge={config.badge} />
      <main data-testid="multipropriedade-page" className="flex-1">
        <NicheHero config={config} />
        <MultipropriedadeFlow config={config} />
        <LegalInfo />
        <NicheGuides niche="multipropriedade" />
      </main>
      <Footer />
    </div>
  );
}
